/**
 * React Query keys for the Users domain.
 *
 * The client omits falsy filters before sending, so `{ search: '' }` and `{}`
 * produce the same HTTP request. Normalizing the key the same way keeps them on
 * one cache entry instead of firing a duplicate request, and sorting the role
 * set means picking DSO then Finance hits the same entry as the reverse.
 */
const normalizeInternalUserFilters = (filters) => {
  const out = {};
  if (filters?.search) out.search = filters.search;
  if (filters?.roles?.length) out.roles = [...filters.roles].sort();

  return out;
};

export const usersKeys = {
  all: ['users'],
  // Matches every page and filter combination of the GoTu Admin list.
  // Invalidation code should use this rather than hand-writing the literal.
  internalUsersPrefix: () => ['users', 'internal-users'],
  internalUsers: (filters, page) => [
    ...usersKeys.internalUsersPrefix(),
    normalizeInternalUserFilters(filters),
    page,
  ],
  // A sibling of the list prefix, not a member of it. `/me` answers a different
  // question about a different route, and nesting it would make every
  // invalidation of the GoTu Admin list refetch the signed-in admin's role too.
  internalUserMe: () => ['users', 'internal-user-me'],
  // One user's NPS answers, as the profile's NPS tab lists them.
  npsReviews: (userId) => ['users', 'nps-reviews', userId],
};
